import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import Loading from "../../components/Loading";
import LinkExpired from "../../layout/LinkExpired";
import Navigation from "../../components/Navigation";
import Payment from "../../layout/Payment";
import { visaAppliedAction } from "../../store/VisaApplied/VisaAppliedReducer";
import { getVisaApplied } from "../../store/VisaApplied/VisaAppliedAction";
import { toast } from "react-toastify";

const PaymentNavigation = () => {
    const { id } = useParams();
    const { visaAppliedLoading, visaAppliedError, visaAppliedDetail, visaAppliedSuccess } = useSelector((state) => state.visaApplied);
    const dispatch = useDispatch();

    useEffect(() => {
        if (visaAppliedError) {
            toast.error("Failed to fetch Payment Page or Data Not found. Please try again...");
            dispatch(visaAppliedAction.clearError());
        }

        if(visaAppliedSuccess){
            dispatch(visaAppliedAction.clearSuccess());
        }
    }, [visaAppliedError, visaAppliedSuccess, dispatch]);


    useEffect(() => {
        dispatch(getVisaApplied({ id }));
    }, [dispatch, id]);

    const formatDate = (date) => {
        const options = {
            day: "numeric",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
        };
        return date.toLocaleDateString("en-US", options);
    };

    const getDate = (deliverDays) => {
        const currentDate = new Date();
        let remainingDays = parseInt(deliverDays, 10);
        let deliveryDate = new Date(currentDate);

        // Loop until all deliverable days are counted
        while (remainingDays > 0) {
            deliveryDate.setDate(deliveryDate.getDate() + 1); // Move to the next day

            // Check if the day is not Saturday (6) or Sunday (0)
            if (deliveryDate.getDay() !== 6 && deliveryDate.getDay() !== 0) {
                remainingDays--; // Only count weekdays
            }
        }

        const formattedDate = formatDate(deliveryDate); // Format as needed
        return formattedDate;
    };

    return (
        <>
            {visaAppliedLoading ? (
                <Loading />
            ) : new Date(getDate(visaAppliedDetail.deliverDays)) > new Date(visaAppliedDetail.departureDate) ? (
                <LinkExpired id={visaAppliedDetail.visaId}/>
            ) : (
                <div className="paymentNavigation__container">
                    <div className="paymentNavigation">
                        <Navigation page={"payment"}></Navigation>
                        <Payment
                            visaAppliedDetail={visaAppliedDetail}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default PaymentNavigation;